import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  StyledContainer,
  TableCell,
  TableWrapper,
  LoaderWrapper,
  TwoColumns,
} from '../../../services/settings/appStyle/global.style';
import { Table, Loader, DropdownButton } from '../../../Components/uielements';
import SubscriptionPlanService from '../../../services/bioplus-services/subscription-plan';
import { IntlMessages } from '../../../helper/langHelper';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import moment from 'moment';
import { exportExcelFile } from '../../../helper/exportExcelHelper';
import { getBillingPeriodLabel } from './constant';
import { getFeatureValue } from './helper';

export function extractData(dataArray) {
  if (dataArray) {
    const extractedData = dataArray?.map((item) => {
      return {
        planName: item.labelName,
        planPrice: item.baseCost,
      };
    });
    return { bioplusUsers: extractedData };
  }
}

const PartnerSubscriptionPlan = () => {
  const [page, setPage] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [pageSize, setPageSize] = useState(10);

  const query = useQuery(['subscriptionPlans', page, pageSize], () =>
    SubscriptionPlanService.getPlans(page, pageSize)
  );

  const tableData = query?.data?.filter((plan) => plan?.type !== 'addOn') ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.plan.name" />,
        accessor: 'labelName',
        width: '22%',
      },
      {
        Header: <IntlMessages id="table.col.period" />,
        accessor: 'billingPeriod',
        Cell: (cellData) => <TableCell>{getBillingPeriodLabel(cellData.value)}</TableCell>,
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.price" />,
        accessor: 'baseCost',
        Cell: (cellData) => <TableCell>$ {cellData.value}</TableCell>,
        width: '10%',
      },
      {
        Header: <IntlMessages id="nav.premises" />,
        accessor: 'premiseLimit',
        Cell: ({ row }) => (
          <TableCell>{getFeatureValue(row.original.features, 'premise', 'limit')}</TableCell>
        ),
        width: '12%',
      },
      {
        Header: <IntlMessages id="nav.geofences" />,
        accessor: 'geofenceLimit',
        Cell: ({ row }) => (
          <TableCell>{getFeatureValue(row.original.features, 'geofence', 'limit')}</TableCell>
        ),
        width: '12%',
      },
      {
        Header: <IntlMessages id="features.premise.range" />,
        accessor: 'premiseRange',
        Cell: ({ row }) => (
          <TableCell>{getFeatureValue(row.original.features, 'premise', 'range')}</TableCell>
        ),
        width: '12%',
      },
      {
        Header: <IntlMessages id="nav.cvd" />,
        accessor: 'edecLimit',
        Cell: ({ row }) => (
          <TableCell>{getFeatureValue(row.original.features, 'edec', 'limit')}</TableCell>
        ),
        width: '12%',
      },
    ],
    []
  );

  if (query.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  const excelFormatData = extractData(query.data);
  const fileName = `Subscription-Plan-${moment().format('DD-MM-YYYY-hh.mm A')}.xlsx`;
  const columnConfig = [
    { header: 'Subscription Name', key: 'planName', width: 30 },
    { header: 'Subscription Price', key: 'planPrice', width: 30 },
  ];

  const handleClickItem = (item) => {
    switch (item?.key) {
      case 'excel':
        exportExcelFile(excelFormatData, fileName, columnConfig);
        break;
      case 'pdf':
        break;
      case 'csv':
        break;
      default:
        break;
    }
  };

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.subscriptionPlans" />
        </HeaderTitle>
        <TwoColumns style={{ gap: '10px' }}>
          {excelFormatData && (
            <DropdownButton
              noOfColoumns={1}
              buttonArray={[
                { key: 'excel', title: 'Export as Excel', icon: <CloudDownloadIcon /> },
              ]}
              onClick={handleClickItem}
            />
          )}
        </TwoColumns>
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={tableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={query?.data?.length || 0}
        />
      </TableWrapper>
    </StyledContainer>
  );
};

export default PartnerSubscriptionPlan;
